export default __webpack_public_path__ + "static/media/flor_mattress.957fcedd.svg";